<app-basic-page [pageTitle]="' '">
  <app-my-account-header-portrait class="header-right"></app-my-account-header-portrait>

  <!-- <div class="page-title">Get Started in 3 Steps</div>
  <div class="horizontal-large top">
    <div
      class="video-list vertical-large"
      [ngClass]="isMobile() ? ['video-list-handset'] : ['video-list-normal']"
    ></div>
  </div> -->

  <div class="home-header">
    <h3>{{ todayStr }}</h3>
    <h1>{{ getGreetings() }}, {{ getUser()?.firstName }}</h1>
  </div>

  <div class="section full-width">
    <h3>My Activity</h3>
    @if (!isMyActivityLoading()) {
      <app-line-chart [chartSeriesDataItem]="chartDateItemList()"></app-line-chart>
    } @else {
      <nz-skeleton [nzActive]="true"></nz-skeleton>
    }
  </div>

  <div class="section full-width">
    <h3>My Assignments</h3>

    <div class="profile-card-grid">
      @if (isMyAssignmentsLoading()) {
        <nz-skeleton [nzActive]="true"></nz-skeleton>
      } @else {
        @for (item of myTaskList(); track $index) {
          <app-scenario-task-card [mode]="'userAssignment'" [task]="item" [boardIdList]="[getMyBoard()!.id]">
          </app-scenario-task-card>
        }
      }
    </div>
  </div>
</app-basic-page>

<app-onboarding-modal [(isVisible)]="isOnboardingModalVisible"></app-onboarding-modal>

<app-content-modal
  [isVisible]="showMobileModal()"
  [title]="'Please sign in using a desktop computer :)'"
  [content]="
    'Please use a desktop or laptop computer with the Google Chrome browser to access Peak Mojo AI for full feature availability.'
  "
  [okText]="'Got it'"
></app-content-modal>
